// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _DribbbleOutlined = /*#__PURE__*/ _interop_require_default(require("@ant-design/icons-svg/lib/asn/DribbbleOutlined"));
var _AntdIcon = /*#__PURE__*/ _interop_require_default(require("../components/AntdIcon"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var DribbbleOutlined = function(props, ref) {
    return /*#__PURE__*/ _react.createElement(_AntdIcon.default, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        icon: _DribbbleOutlined.default
    }));
};
/**![dribbble](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA5NkMyODIuNiA5NiA5NiAyODIuNiA5NiA1MTJzMTg2LjYgNDE2IDQxNiA0MTYgNDE2LTE4Ni42IDQxNi00MTZTNzQxLjQgOTYgNTEyIDk2em0yNzUuMSAxOTEuOGM0OS41IDYwLjUgNzkuNSAxMzcuNSA4MC4yIDIyMS40LTExLjctMi41LTEyOS4yLTI2LjMtMjQ3LjQtMTEuNC0yLjUtNi4xLTUtMTIuMi03LjYtMTguMy03LjQtMTcuMy0xNS4zLTM0LjYtMjMuNi01MS41QzcyMCAzNzQuMyA3NzkuNiAyOTggNzg3LjEgMjg3Ljh6TTUxMiAxNTcuMmM5MC4zIDAgMTcyLjggMzMuOSAyMzUuNSA4OS41LTYuNCA5LjEtNTkuOSA4MS0xODYuMiAxMjguNC01OC4yLTEwNy0xMjIuNy0xOTQuOC0xMzIuNi0yMDggMjcuMy02LjYgNTUuMi05LjkgODMuMy05Ljl6TTM2MC45IDE5MWM5LjQgMTIuOCA3Mi45IDEwMC45IDEzMS43IDIwNS41QzMyNi40IDQ0MC42IDE4MCA0NDAgMTY0LjEgNDM5LjhjMjMuMS0xMTAuMyA5Ny40LTIwMS45IDE5Ni44LTI0OC44ek0xNTYuNyA1MTIuNWMwLTMuNi4xLTcuMy4yLTEwLjkgMTUuNS4zIDE4Ny43IDIuNSAzNjUuMi01MC42IDEwLjIgMTkuOSAxOS45IDQwLjEgMjguOCA2MC4zLTQuNyAxLjMtOS40IDIuNy0xNCA0LjJDMzUzLjYgNTc0LjkgMjU2LjEgNzM2LjQgMjQ4IDc1MC4xYy01Ni43LTYzLTkxLjMtMTQ2LjMtOTEuMy0yMzcuNnpNNTEyIDg2Ny44Yy04Mi4yIDAtMTU3LjktMjgtMjE4LjEtNzUgNi40LTEzLjEgNzguMy0xNTIgMjc4LjctMjIxLjlsMi4zLS44YzQ5LjkgMTI5LjYgNzAuNSAyMzguMyA3NS44IDI2OS41QTM1MC40NiAzNTAuNDYgMCAwMTUxMiA4NjcuOHptMTk4LjUtNjAuN2MtMy42LTIxLjYtMjIuNS0xMjUuNi02OS0yNTMuM0M3NTIuOSA1MzYgODUwLjcgNTY1LjIgODYyLjggNTY5Yy0xNS44IDk4LjgtNzIuNSAxODQuMi0xNTIuMyAyMzguMXoiIC8+PC9zdmc+) */ var RefIcon = /*#__PURE__*/ _react.forwardRef(DribbbleOutlined);
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'DribbbleOutlined';
}
var _default = RefIcon;
